import { useContext } from "react";
import { SearchContext } from "../../Store/Search.store";
import styles from "./pagination.module.css";

export default function Pagination() {
    const { searchData, setSearchData } = useContext(SearchContext);
    const totalPages = Math.ceil(searchData.data.items.length / 16);

    const handlePageChange = (page: number) => {
        if (page < 1 || page > totalPages) return;
        setSearchData(prevState => ({
            ...prevState,
            currentPage: page
        }));
    }

    // Logic to show limited number of page buttons
    const getVisiblePageNumbers = () => {
        const maxVisibleButtons = 5; // Maximum number of visible page buttons
        const halfVisibleButtons = Math.floor(maxVisibleButtons / 2);
        
        let startPage = Math.max(searchData.currentPage - halfVisibleButtons, 1);
        let endPage = Math.min(startPage + maxVisibleButtons - 1, totalPages);
        
        // Adjust start page if we're near the end
        if (endPage - startPage + 1 < maxVisibleButtons) {
            startPage = Math.max(endPage - maxVisibleButtons + 1, 1);
        }
        
        return Array.from(
            { length: endPage - startPage + 1 }, 
            (_, i) => startPage + i
        );
    };

    return (
        <>
        {totalPages > 0 &&
            <div className={styles.pagination}>
                {searchData.currentPage > 1 &&
                    <button className={styles.previous} onClick={() => handlePageChange(searchData.currentPage - 1)}>Previous</button>
                }
                <div>
                    {searchData.currentPage > 3 && (
                        <>
                            <button
                                className={styles.page}
                                onClick={() => handlePageChange(1)}
                            >
                                1
                            </button>
                            {searchData.currentPage > 4 && (
                                <span className={styles.ellipsis}>...</span>
                            )}
                        </>
                    )}
                    
                    {getVisiblePageNumbers().map(pageNumber => (
                        <button
                            key={pageNumber}
                            className={`${styles.page} ${pageNumber === searchData.currentPage ? styles.active : ''}`}
                            onClick={() => handlePageChange(pageNumber)}
                        >
                            {pageNumber}
                        </button>
                    ))}
                    
                    {searchData.currentPage < totalPages - 2 && (
                        <>
                            {searchData.currentPage < totalPages - 3 && (
                                <span className={styles.ellipsis}>...</span>
                            )}
                            <button
                                className={styles.page}
                                onClick={() => handlePageChange(totalPages)}
                            >
                                {totalPages}
                            </button>
                        </>
                    )}
                </div>
                {searchData.currentPage < totalPages &&
                    <button className={styles.next} onClick={() => handlePageChange(searchData.currentPage + 1)}>Next</button>
                }
            </div>
        }
        </>
    );
}